import { ChartTheme } from "../models/window-wrapper/marketing-webchart-window-wrapper.model";

export class WebChartThemeHelpers {
    public static getTheme(themeString: string) {
        if (themeString.toLowerCase() === 'dark') {
            return ChartTheme.Dark;
        } else if (themeString.toLowerCase() === 'black') {
            return ChartTheme.Black;
        } else if (themeString.toLowerCase() === 'lightblue') {
            return ChartTheme.LightBlue;
        } else if (themeString.toLowerCase() === 'updatedwebdark') {
            return ChartTheme.UpdatedWebDark;
        }
        
        return ChartTheme.Light;
    }
}